export default __webpack_public_path__ + "static/media/icon_plus.eb23d1ce.svg";